import { MouseEvent, useState } from "react";
import IconButton from "@material-ui/core/IconButton";
import MoreVert from "@material-ui/icons/MoreVert";
import MenuItem from "@material-ui/core/MenuItem";
import { Info } from "@material-ui/icons";
import { Link, useLocation } from "react-router-dom";
import { useUsersStyles } from "../../styles";
import { Menu } from "@material-ui/core";

type UsersActionsProps = {
  id: number;
};

export default function UsersActions({ id }: UsersActionsProps) {
  const { pathname } = useLocation();
  const { classes } = useUsersStyles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        <MoreVert />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        keepMounted
      >
        <MenuItem
          component={Link}
          to={`${pathname}/${id}/informacoes`}
          onClick={handleClose}
          className={classes.ActionsMenuItem}
        >
          <Info htmlColor="#706E7A" />
          Informações
        </MenuItem>
      </Menu>
    </>
  );
}
